import { render, staticRenderFns } from "./Page015.vue?vue&type=template&id=5208150b&scoped=true&"
import script from "./Page015.vue?vue&type=script&lang=js&"
export * from "./Page015.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5208150b",
  null
  
)

export default component.exports